// Local storage keys for chat persistence
export const CHAT_MESSAGES_KEY = 'chatMessages';
export const CHAT_MESSAGES_TIMESTAMP_KEY = 'chatMessagesTimestamp';
export const ROOM_MEMBERS_KEY = 'roomMembers';

// Clean up old messages (older than 24 hours)
export const cleanupOldMessages = () => {
    try {
        const allChatMessages = JSON.parse(localStorage.getItem(CHAT_MESSAGES_KEY) || '{}');
        const allRoomMembers = JSON.parse(localStorage.getItem(ROOM_MEMBERS_KEY) || '{}');
        const currentTime = Date.now();
        const twentyFourHours = 24 * 60 * 60 * 1000;
        
        Object.keys(allChatMessages).forEach(roomId => {
            if (currentTime - allChatMessages[roomId].timestamp > twentyFourHours) {
                delete allChatMessages[roomId];
            }
        });
        
        Object.keys(allRoomMembers).forEach(roomId => {
            if (currentTime - allRoomMembers[roomId].timestamp > twentyFourHours) {
                delete allRoomMembers[roomId];
            }
        });
        
        localStorage.setItem(CHAT_MESSAGES_KEY, JSON.stringify(allChatMessages));
        localStorage.setItem(ROOM_MEMBERS_KEY, JSON.stringify(allRoomMembers));
    } catch (error) {
        console.error('Error cleaning up old data:', error);
    }
};

export const saveChatMessagesToStorage = (roomId, messages) => {
    try {
        const allChatMessages = JSON.parse(localStorage.getItem(CHAT_MESSAGES_KEY) || '{}');
        allChatMessages[roomId] = {
            messages: messages,
            timestamp: Date.now()
        };
        localStorage.setItem(CHAT_MESSAGES_KEY, JSON.stringify(allChatMessages));
        localStorage.setItem(CHAT_MESSAGES_TIMESTAMP_KEY, Date.now().toString());
    } catch (error) {
        console.error('Error saving chat messages to storage:', error);
    }
};

export const saveRoomMembersToStorage = (roomId, members) => {
    try {
        const allRoomMembers = JSON.parse(localStorage.getItem(ROOM_MEMBERS_KEY) || '{}');
        allRoomMembers[roomId] = {
            members: members,
            timestamp: Date.now()
        };
        localStorage.setItem(ROOM_MEMBERS_KEY, JSON.stringify(allRoomMembers));
        console.log('Saved room members to storage:', Object.keys(members).length);
    } catch (error) {
        console.error('Error saving room members to storage:', error);
    }
};

export const getChatMessagesFromStorage = (roomId) => {
    try {
        const allChatMessages = JSON.parse(localStorage.getItem(CHAT_MESSAGES_KEY) || '{}');
        const roomData = allChatMessages[roomId];
        if (roomData && roomData.messages) {
            // Check if messages are not too old (24 hours)
            const currentTime = Date.now();
            const twentyFourHours = 24 * 60 * 60 * 1000;
            if (currentTime - roomData.timestamp < twentyFourHours) {
                return roomData.messages;
            }
        }
        return null;
    } catch (error) {
        console.error('Error loading chat messages from storage:', error);
        return null;
    }
};

export const getRoomMembersFromStorage = (roomId) => {
    try {
        const allRoomMembers = JSON.parse(localStorage.getItem(ROOM_MEMBERS_KEY) || '{}');
        const roomData = allRoomMembers[roomId];
        if (roomData && roomData.members) {
            return roomData.members;
        }
        return null;
    } catch (error) {
        console.error('Error loading room members from storage:', error);
        return null;
    }
};
